import { render } from "./offcanvas.vue?vue&type=template&id=4edd18e5"
import script from "./offcanvas.vue?vue&type=script&lang=js"
export * from "./offcanvas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__